import { _ as __assign } from './_tslib-ff3a08af.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { makeStyles, createStyles, useForkRef, CircularProgress } from '@material-ui/core';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import { debounce } from 'lodash';
import React, { useState, useRef, useCallback, useEffect } from 'react';
import './globalButtonStyles-41c8af84.js';
import { s as styleConstants } from './constants-3b80be2a.js';

var useSearchInputStyles = makeStyles(function (theme) {
    return createStyles({
        inputContainer: {
            height: '42px',
            position: 'relative',
            flex: '1',
            '& input': {
                border: '2px solid #D5D5D5',
                borderRadius: '5px',
                color: '#596379',
                height: '40px',
                paddingLeft: '34px',
                paddingRight: '34px',
                position: 'absolute',
                top: '0px',
                width: '100%',
                zIndex: 1,
                outline: 'none',
                boxSizing: 'border-box',
                '& :focus': {
                    outline: 'none'
                },
                '&::-ms-clear': {
                    display: 'none'
                }
            }
        },
        searchIcon: {
            position: 'absolute',
            top: '9px',
            left: '10px',
            zIndex: 10,
            width: '20px'
        },
        clearIcon: {
            cursor: 'pointer',
            position: 'absolute',
            top: '9px',
            right: '10px',
            zIndex: 10,
            width: '20px'
        },
        loader: {
            position: 'absolute',
            top: '9px',
            right: '10px',
            zIndex: 10
        }
    });
});

var SearchInput = React.forwardRef(function (props, ref) {
    var placeholder = props.placeholder,
        onFilterChange = props.onFilterChange,
        defaultValue = props.defaultValue,
        dataTestId = props.dataTestId;
    var classes = useSearchInputStyles({});
    var _a = useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : ''),
        inputValue = _a[0],
        setFilterValue = _a[1];
    var inputRef = useRef(null);
    var handleInputRef = useForkRef(inputRef, ref);
    var handleFilterValChange = function (event) {
        setFilterValue(event.currentTarget.value);
    };
    var updateQuery = function () {
        if (props.value === undefined || props.value != inputValue) {
            onFilterChange(inputValue);
        }
    };
    var delayedQuery = useCallback(debounce(updateQuery, 500), [inputValue]);
    useEffect(function () {
        delayedQuery();
        return delayedQuery.cancel;
    }, [inputValue]);
    useEffect(function () {
        if (props.value !== undefined) {
            setFilterValue(props.value);
        }
    }, [props.value]);
    var clearFilterValue = function () {
        setFilterValue('');
    };
    return jsxs("div", { className: classes.inputContainer, "data-testid": dataTestId, children: [jsx("input", __assign({}, props.autocompleteInputProps, { placeholder: placeholder, type: "text", value: inputValue, onChange: handleFilterValChange, ref: handleInputRef, style: props.newEditableLook ? { border: "2px solid ".concat(styleConstants.colors.primaryColor) } : {} })), jsx(SearchIcon, { className: classes.searchIcon }), !!inputValue && !props.loading && jsx(ClearIcon, { onClick: clearFilterValue, className: classes.clearIcon }), props.loading && jsx(CircularProgress, { className: classes.loader, color: "primary", size: 20 })] });
});

export { SearchInput as S, useSearchInputStyles as u };
